<template>
  <div class="project">
    <slot />
    <RelatedProjects v-if="relatedProjects" :items="relatedProjects" />
  </div>
</template>

<script>
import { Project } from 'beisheim/models'
import editable from '@i22/frontend-cms-utils/mixins/editable'
import RelatedProjects from 'beisheim/components/elements/related-projects'
import matomoPageTracker from 'beisheim/mixins/matomo-page-tracker'

export default {
  components: {
    RelatedProjects
  },
  mixins: [ editable, matomoPageTracker ],
  computed: {
    relatedProjects () {
      // To make sure all getters exists (expecially language and country)
      const currentProject = Project.find(this.resource.id)
      return Project
        .query()
        .where(r => !!(r.columns.teaser.media && r.columns.teaser.media.path))
        .where(r => r.id !== currentProject.id)
        .where(r => r.columns.focus === currentProject.columns.focus)
        .where(r => r.language === currentProject.language && r.country === currentProject.country)
        .get()
    }
  },
  head () {
    return {
      title: `Projekt "${this.resource.columns.meta_title || this.resource.columns.title}"`
    }
  }
}
</script>
